module.exports = __webpack_public_path__ + "img/peter_s.33d88d98.png";